import { ReactComponent as DateIcon } from './date.svg';
import { ReactComponent as DateTimeIcon } from './datetime.svg';
import { ReactComponent as TimeIcon } from './time.svg';

export default {
  date: DateIcon,
  time: TimeIcon,
  datetime: DateTimeIcon,
};
